<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'unpaidcustomers'"
      :items="items"
      :loading="loading"
      :display-name-plural="$t('entities.UnpaidCustomer.Plural')"
      :display-name-singular="$t('entities.UnpaidCustomer.Singular')"
      :permission-name="'Customers'"
      :remove-message="$t('DeleteCustomer.RemoveMessage')"
      :remove-path="'/admin/customers/deletecustomer'"
      @reloadData="reload()"
      :allow-create="false"
      :items-per-page="itemsPerPage"
      :allow-edit="false"
      :exclude-fields="['id', 'noPaymentTypeChosen']">
      <template v-if="productTypes.length !== 0"
                #cell(productTypeId)="row">
        {{ productTypes.find(x => x.id === row.item.productTypeId).name }}
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="$t('common.ContactByEmail')"
          :enterable="false"
          placement="top">
          <b-button class="mx-1"
                    variant="primary"
                    @click="emailId = row.item.id; message = ''; $refs.sendByEmailModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="envelope-open" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.CreateBankTransferPayment')"
          :enterable="false"
          placement="top"
          v-if="$auth.check(
            'Permissions.AdminPanel.Customers.Edit'
          ) && row.item.noPaymentTypeChosen">
          <b-button class="mx-1"
                    variant="success"
                    @click="customerId = row.item.id; $refs.createBankTransferPaymentModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="money-bill-wave" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="sendByEmailModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ContactByMail') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-left">
        {{ $t('common.Message') }}:
      </p>
      <ValidationObserver
        ref="sendByEmailObserver"
        v-slot="{invalid}"
        tag="form">
        <div class="row">
          <div class="col-lg-12">
            <ValidationProvider
              name="message"
              rules="required"
              v-slot="{errors, classes}">
              <b-form-textarea
                v-model="message"
                :class="{...classes, myInput: true}"
                :placeholder="$t('common.Message')"
                no-resize
                rows="7" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
      </ValidationObserver>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="message = ''; emailId =0; $refs.sendByEmailModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="success"
          @click="send();">
          {{ $t('common.Send') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="createBankTransferPaymentModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.CreateBankTransferPayment') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyCreateBankTransferPaymentQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="customerId = null; $refs.createBankTransferPaymentModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="createBankTransferPayment();">
          {{ $t('common.Yes') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  data() {
    return {
      items: [],
      loading: true,
      productTypes: [],
      message: '',
      emailId: 0,
      customerId: null
    };
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.axios.get('/admin/users/getunpaidcustomers')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.items = res.data.result;
          } else {
            this.items = [];
          }
          this.loading = false;
        }).catch((err) => Promise.reject(err)).finally(() => {
          this.$refs.DataTable.finishSpinner();
        });

      this.axios.get('/admin/ProductTypes')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.productTypes = res.data.result;
          }
          Promise.resolve(this.productVouchers);
        })
        .catch((err) => Promise.reject(err));
    },
    send() {
      this.axios.post('/admin/customers/contactunpaidcustomer', {
        Id: this.emailId,
        Message: this.message
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('common.EmailSent'), {
          title: this.$t('common.EmailSuccessfullySent'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.emailId = 0;
        this.message = '';
        this.$refs.sendByEmailModal.hide();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('common.EmailNotSent'), {
          title: this.$t('common.EmailUnSuccessfullySent'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.emailId = 0;
        this.message = '';
        this.$refs.sendByEmailModal.hide();
      });
    },
    createBankTransferPayment() {
      this.axios.put('/admin/customers/createbanktransferpayment', {
        CustomerId: this.customerId
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('CreateBankTransferPayment.SuccessToast.Body'), {
          title: this.$t('CreateBankTransferPayment.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.customerId = null;
        this.$refs.createBankTransferPaymentModal.hide();
        this.$router.push({ name: 'admin.finances.payments.view'});
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('CreateBankTransferPayment.FailToast.Body'), {
          title: this.$t('CreateBankTransferPayment.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.customerId = null;
        this.$refs.createBankTransferPaymentModal.hide();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
